import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { SeatingDetailStore, SeatingDetailState } from './seating-detail.store';
import { Observable } from 'rxjs';
import { SeatingDetail } from './seating-detail.model';

@Injectable({ providedIn: 'root' })
export class SeatingDetailQuery extends QueryEntity<SeatingDetailState> {
  constructor(protected store: SeatingDetailStore) {
    super(store);
  }

  selectCurrentSeatingDetails(): Observable<SeatingDetail | undefined> {
    return this.selectFirst();
  }
}
